/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';


export const shorteners = (state = defaultState.shorteners, action) => {
    let nextState = Utilities.deepClone(state),
        i = 0,
        shorteners = [];

    if (action.status === constants.STATE_SUCCESS) {
        switch (action.type) {
            case constants.SHORTENER_LIST:
                nextState = action.payload;
                break;

            case constants.SHORTENER_SHOW:
            case constants.SHORTENER_UPDATE:
                for (i = 0; i < nextState.length; ++i) {
                    if (parseInt(nextState[i].id, 10) === parseInt(action.payload.id, 10)) {
                        nextState[i] = action.payload;
                        break;
                    }
                }
                break;

            case constants.SHORTENER_DELETE:
                for (i = 0; i < nextState.length; ++i) {
                    if (parseInt(nextState[i].id, 10) !== parseInt(action.payload.id, 10)) {
                        shorteners.push(nextState[i]);
                    }
                }
                nextState = shorteners;
                break;

            case constants.SHORTENER_CREATE:
                nextState.push(action.payload);
                break;

            case constants.SHORTENER_APPLY:
                // TODO: figure out what to do after apply
                break;

            case constants.SHORTENER_LOG:
                for (i = 0; i < nextState.length; ++i) {
                    if (parseInt(nextState[i].id, 10) === parseInt(action.payload.id, 10)) {
                        nextState[i].log = action.payload;
                        break;
                    }
                }
                break;

            case constants.SHORTENER_TEST:
                for (i = 0; i < nextState.length; ++i) {
                    if (parseInt(nextState[i].id, 10) === parseInt(action.payload.id, 10)) {
                        nextState[i].testResult = action.payload;
                        break;
                    }
                }
                break;

            default:
                break;

        }
    }

    return nextState;
};
